import { render, staticRenderFns } from "./delivery-staffs.vue?vue&type=template&id=7d60f21d&"
import script from "./delivery-staffs.vue?vue&type=script&lang=js&"
export * from "./delivery-staffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports